// extracted by mini-css-extract-plugin
export default {"tbx_action_btn":"actionButton_tbx_action_btn__23cwM"};